import * as Yup from "yup";
import { useLegalEntities } from "../hooks/useLegalEntities";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { InitialRequestConfig } from "../models/flexible/initial-request";
import { Maybe } from "../models/generated/graphql";
import { GeneralFieldController } from "./general-field-controller";
import { GET_LEGAL_ENTITIES } from "./queries";
import { ControlState } from "../models/flexible/control-state";
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";

export class LegalEntityFieldController extends GeneralFieldController {
	getInitialRequestComponents(): InitialRequestConfig {
		return { queries: [GET_LEGAL_ENTITIES], variables: {} };
	}

	override useControlProps(): Maybe<FlexControlProps> | undefined {
		const legalEntities = useLegalEntities();
		return {
			controlType: "combo",
			options: legalEntities,
		};
	}

	override mapInitialValue(value: unknown): unknown {
		return (
			value ||
			this.parent.context.startingPoint?.data[AttributeIdentifiers.LegalEntity as any] ||
			""
		);
	}

	override useControlState(): ControlState {
		return this.parent.context.noPatients && this.parent.context.noPatients > 0 ? "hidden" : "enabled";
	}

	protected override createFieldValidationRuleByDataType(): Yup.AnySchema {
		return Yup.object().nullable();
	}
}
